import { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Maximize2, Minus, Plus, RotateCcw, X } from 'lucide-react';
import { img } from '../data/siteData';

const slides = [
  'equipment/horizontal-balers/horizontal-7.jpg',
  'equipment/horizontal-balers/horizontal-3.jpg',
  'equipment/horizontal-balers/horizontal-8.jpg',
  'equipment/vertical-balers/vertical-3.jpg',
  'equipment/custom-specialty-equipment/custom-specialty-equipment-1.jpg',
  'equipment/compactors/precrush-compactor.jpg',
];

function HomeSlideshow() {
  const [active, setActive] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const [zoom, setZoom] = useState(1);

  const clampZoom = (value) => Math.min(3, Math.max(1, Number(value.toFixed(2))));
  const changeZoom = (amount) => setZoom((value) => clampZoom(value + amount));
  const stepSlide = (direction) => {
    setActive((index) => (index + direction + slides.length) % slides.length);
    setZoom(1);
  };
  const closeExpanded = () => {
    setExpanded(false);
    setZoom(1);
  };
  const handleWheelZoom = (event) => {
    event.preventDefault();
    event.stopPropagation();
    changeZoom(event.deltaY > 0 ? -0.15 : 0.15);
  };

  useEffect(() => {
    if (expanded) return undefined;
    const timer = window.setInterval(() => {
      setActive((index) => (index + 1) % slides.length);
    }, 4200);

    return () => window.clearInterval(timer);
  }, [expanded]);

  useEffect(() => {
    if (!expanded) return undefined;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [expanded]);

  return (
    <>
      <div className="home-slideshow" aria-label="C+M baling equipment slideshow">
        <button type="button" className="home-slide-expand" onClick={() => setExpanded(true)} aria-label="Expand homepage slideshow image">
          {slides.map((slide, index) => (
            <img
              key={slide}
              className={index === active ? 'active' : ''}
              src={img(slide)}
              alt="C+M baling and material handling equipment"
            />
          ))}
          <span><Maximize2 size={15} /> Expand</span>
        </button>
        <div className="slide-controls" aria-label="Homepage slideshow controls">
          <button type="button" onClick={(event) => { event.stopPropagation(); stepSlide(-1); }} aria-label="Show previous homepage slide">
            <ChevronLeft size={18} />
          </button>
          <div className="slide-dots" aria-hidden="true">
            {slides.map((slide, index) => (
              <span key={slide} className={index === active ? 'active' : ''} />
            ))}
          </div>
          <button type="button" onClick={(event) => { event.stopPropagation(); stepSlide(1); }} aria-label="Show next homepage slide">
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
      {expanded ? (
        <div className="image-modal" role="dialog" aria-modal="true" aria-label="Homepage slideshow photo viewer" onWheel={handleWheelZoom}>
          <button className="modal-close" type="button" onClick={closeExpanded} aria-label="Close image viewer"><X size={22} /></button>
          <div className="zoom-controls" aria-label="Image zoom controls">
            <button type="button" onClick={() => changeZoom(-0.25)} aria-label="Zoom out"><Minus size={18} /></button>
            <span>{Math.round(zoom * 100)}%</span>
            <button type="button" onClick={() => changeZoom(0.25)} aria-label="Zoom in"><Plus size={18} /></button>
            <button type="button" onClick={() => setZoom(1)} aria-label="Reset zoom"><RotateCcw size={17} /></button>
          </div>
          <button className="modal-step left" type="button" onClick={() => stepSlide(-1)} aria-label="Previous photo"><ChevronLeft size={28} /></button>
          <div className="modal-image-stage">
            <img style={{ transform: `scale(${zoom})` }} src={img(slides[active])} alt="C+M equipment expanded slideshow view" />
          </div>
          <button className="modal-step right" type="button" onClick={() => stepSlide(1)} aria-label="Next photo"><ChevronRight size={28} /></button>
        </div>
      ) : null}
    </>
  );
}

export default HomeSlideshow;
